import(/* webpackMode: "eager", webpackExports: ["Payments"] */ "/app/src/components/footerStaticPages/PaymentMethods/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/skeletons/GeneralSkeleton.tsx");
